import request from "@/router/axios";
// import store from '@/store/';

export const getList = (current, size, params) => {
  // if(params.orgId2){
  //   params.orgId = params.orgId2
  // }
  // delete params.orgId2
  // console.log(params,'params.orgId2params.orgId2params.orgId2');
  return request({
    url: "/api/infox-masterdata/promoter/list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};

// 新增
export const add = (data) => {
  return request({
    url: "/api/infox-masterdata/positionAllocation/saveOrUpdate",
    method: "post",
    data,
  });
};

// 清空
export const remove = () => {
  return request({
    url: "/api/infox-masterdata/positionAllocation/clear",
    method: "post",
  });
};

// 下载模板
export const exportMould = () => {
  return request({
    url: "/api/infox-masterdata/positionAllocation/exportMould",
    method: "get",
    responseType: "blob",
  });
};

// 导入excel
export function upload(file) {
  let formData = new FormData();
  formData.append("file", file);
  return request({
    url: `/api/infox-masterdata/positionAllocation/import`,
    method: "post",
    data: formData,
  });
}

// 编辑
export const update = ({ id, staffingNum, status }) => {
  return request({
    url: "/api/infox-masterdata/positionAllocation/update",
    method: "post",
    data: {
      id,
      staffingNum,
      status,
    },
  });
};

// 导出
export function download({ current, size, params }) {
  return request({
    url: `/api/infox-masterdata/promoter/export`,
    method: "get",
    responseType: "blob",
    params: {
      ...params,
      current,
      size,
    },
  });
}

//门店三月业绩
export const selectByThreeMonths = ({ storeCode }) => {
  return request({
    url: "/api/infox-promotion/sales/data/total/selectByThreeMonths",
    method: "get",
    params: {
      storeCode,
    },
  });
};

//门店三月业绩
export const approveDetail = ({ personCode }) => {
  return request({
    url: "/api/infox-promotion/approve/detail" + personCode,
    method: "get",
  });
};

//修改备注
export const updateRemark = ({ personCode, remark }) => {
  return request({
    url: "/api/infox-masterdata/promoter/update/remark/" + personCode,
    method: "post",
    params: {
      remark,
    },
  });
};

//详情
export const getDetail = (id) => {
  return request({
    url: "/api/infox-masterdata/promoter/detail/" + id,
    method: "get",
  });
};

//获取门店列表
export const getStoreList = (current, size, params) => {
  return request({
    url: "/api/infox-masterdata/promoter/store/list",
    method: "get",
    params: {
      current,
      size,
      ...params,
      // storeName:storeName
    },
  });
};

//获取直接上级列表
export const getManagerPersonList = (params) => {
  return request({
    url: "/api/infox-masterdata/promoter/manager/person/list",
    method: "get",
    params: {
      ...params,
    },
  });
};

//获取经销商列表
export const getPromoterDealerList = (params) => {
  return request({
    url: "/api/infox-masterdata/promoter/dealer/list",
    method: "get",
    params: {
      ...params,
    },
  });
};

//激活
export function promoterActivation({ personCode }) {
  return request({
    url: `/api/infox-masterdata/promoter/activation/` + personCode,
    method: "post",
  });
}

//删除单条
export function cancelDraft({ personCode }) {
  return request({
    url: `/api/infox-masterdata/promoter/cancel/draft/` + personCode,
    method: "post",
  });
}

export const cancelDel = (personCode) => {
  return request({
    url: `/api/infox-masterdata/promoter/delete/${personCode}`,
    method: "post",
  });
};

//人员状态
export function personStatuslList() {
  return request({
    url: "/api/infox-masterdata/promoter/personStatus/list",
    method: "get",
  });
}

//审核状态
export function approveStatusList() {
  return request({
    url: "/api/infox-masterdata/promoter/approveStatus/list",
    method: "get",
  });
}

//识别身份证
export function OCRIdcard(file) {
  return request({
    url: "/api/infox-system/validate-idCard-frontImg",
    method: "post",
    data: {
      frontImg: file,
    },
  });
}

//生成唯一的用户编码
export function createPersonCode({ orgId, orgPositionId }) {
  return request({
    url: "/api/infox-masterdata/promoter/createPersonCode",
    method: "post",
    params: {
      orgId,
      orgPositionId,
    },
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

//新增
export function save(params) {
  return request({
    url: "/api/infox-masterdata/promoter/save",
    method: "post",
    data: {
      ...params,
    },
  });
}

//离职，转岗，草稿
export function draft2(params) {
  return request({
    url: "/api/infox-masterdata/promoter/draft",
    method: "post",
    data: {
      ...params,
    },
  });
}

//离职提交
export function promoterDepart(params) {
  return request({
    url: "/api/infox-masterdata/promoter/depart",
    method: "post",
    data: {
      ...params,
    },
  });
}

//新入职草稿
export function draft(params) {
  return request({
    url: "/api/infox-masterdata/promoter/newPost/draft",
    method: "post",
    data: {
      ...params,
    },
  });
}

//变更提交
export function promoterChange(params) {
  return request({
    url: "/api/infox-masterdata/promoter/change",
    method: "post",
    data: {
      ...params,
    },
  });
}

// 识别银行卡
export function IdentifyBankCards(file) {
  return request({
    url: "/api/infox-masterdata/app/user/validate-bankcard",
    method: "post",
    data: {
      imgParam: file,
    },
  });
}

export function positionIsJL(params) {
  return request({
    url: "/api/infox-masterdata/common/positionIsJL",
    method: "get",
    params: {
      ...params,
    },
  });
}

export function getIsSalesPage(params) {
  return request({
    url: "/api/infox-masterdata/common/isSalesPage",
    method: "get",
    params: {
      ...params,
    },
  });
}

export function getFullTimePersonNumber(storeCode) {
  return request({
    url: `/api/infox-masterdata/promoter/getZZByStoreCode/${storeCode}`,
    method: "get",
  });
}

//银行卡校验
export function validateBankAuth(params) {
  return request({
    url: "/api/infox-masterdata/app/user/validate-bank-auth",
    method: "post",
    data: {
      ...params,
    },
  });
}
//退出登录
export function loginOut() {
  return request({
    url: `/api/infox-auth/login/out`,
    method: "get",
  });
}
